import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import './Blog.css';

const sliderSettings = {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

const Blog = () => {
  const [blogData, setBlogData] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setBlogData(data.blogs);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <section className="blog-section section-pad" id="blog">
      <div className="container">
        {/* Section Header */}
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-5" data-aos="fade-up">
          <div>
            <span className="section-tag">Latest Insights</span>
            <h2 className="blog-heading mb-0">
              Explore practical perspectives on SAP transformation, enterprise data strategy, responsible AI, and emerging technology trends.
            </h2>
          </div>
        </div>
        {/* Blog Slider */}
        <div className="blog-slider-wrap" data-aos="fade-up" data-aos-delay="100">
          <Slider {...sliderSettings} className="blog-slider">
            {blogData.map((post) => {
              const date = new Date(post.posted_date);

              return (
                <div className="blog-slide-item" key={post.id}>
                  <div className="blog-card">
                    <div className="blog-img-wrap">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${post.folder_path}/${post.image}`}
                        alt={post.title}
                        className="blog-img"
                      />

                      <div className="blog-date-badge">
                        <span className="date-day">
                          {String(date.getDate()).padStart(2, "0")}
                        </span>

                        <span className="date-month">
                          {date.toLocaleString("en-US", { month: "short" })}
                        </span>
                      </div>
                    </div>

                    <div className="blog-body">
                      <h4 className="blog-title">{post.name}</h4>
                      <p className="blog-desc">{post.short_description}</p>

                      <a href="#blog" className="blog-link">
                        Explore More
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>

        <div className='text-center'>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#blog" className="btn-view-all mt-3 mt-md-0">
            View All
          </a>
        </div>

      </div>
    </section>
  );
};

export default Blog;
